module.exports = __webpack_public_path__ + "first-5_raised_print.jpg?ced475e929121244ce0da932aff9a317";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_raised_print.jpg
// module id = 587
// module chunks = 0